import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { ComponentProps, FC, useCallback } from 'react';
import { useRouter } from 'shared-routing';
import { Routes } from '@common/constants';
import { parseDateToString } from '@utils/helpers';
import { DateCategoryPicker as DateCategoryPickerV1 } from '../JourneyPicker/DateCategoryPicker/DateCategoryPicker';
import { JourneyPickerV2Connected } from './container';
import { useNavCategories } from './useNavCategories';
import { useCategoryNavigation } from './useCategoryNavigation';
import type { JourneyBarSearchParams } from './JourneyPickerV2';

type V1Props = ComponentProps<typeof DateCategoryPickerV1>;

export const DateCategoryPickerVersion: FC<V1Props> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2.spa-days');
  const router = useRouter();
  const categories = useNavCategories();
  const handleCategoryChange = useCategoryNavigation();

  const handleSearchComplete = useCallback(
    (params: JourneyBarSearchParams) => {
      router.push(
        {
          pathname: Routes.SPA_DAY_LIST,
          query: { arrivalDate: parseDateToString(params.fromDate) },
        },
        undefined,
        { shallow: true }
      );
    },
    [router]
  );

  if (isV2) {
    return (
      <JourneyPickerV2Connected
        dateMode="single"
        dateContext="spa"
        categories={categories}
        category="spa"
        onCategoryChange={handleCategoryChange}
        onSearchComplete={handleSearchComplete}
      />
    );
  }

  return <DateCategoryPickerV1 {...props} />;
};
